import React from 'react';
import ReactDOM from 'react-dom';
import Auth from './auth';

// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';

import '../scss/style.scss'

ReactDOM.render(<Auth />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js